export default __webpack_public_path__ + "static/media/Monger-HUD-Targeting (Reticle).cb2f2c92.jpg";